export default "__VITE_ASSET__BUurQchC__"